import appVersion from "../../constants/appVersion";

const Footer = () => (
  <footer className="footer">
    <div>
      Libretodo Web v{appVersion} © Eduvar Software Pvt Ltd, 2023.
      LibreTODO is open source under the{" "}
      <a href="https://opensource.org/license/bsd-3-clause">
        3-clause BSD license
      </a>
      . Follow LibreTODO on{" "}
      <a href="https://github.com/eduvarsoftware/libretodo">GitHub</a>.
    </div>
  </footer>
);

export default Footer;
